<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <!-- Feeds-->
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer mt-5">
                <v-text-field
                  v-model="searchTextModel"
                  :label="$t('labels.search')"
                  v-on:keyup.enter="searchText"
                  clearable
                  clear-icon="mdi-close-circle"
                  @click:clear="clearSearch"
                  outlined
                  class="mx-4"
                  color="defaultColor"
                  rounded
                >
                  <template v-slot:append>
                    <v-btn
                      rounded
                      small
                      elevation="0"
                      dark
                      :disabled="
                        searchTextModel ? searchTextModel.length < 3 : false
                      "
                      color="defaultColor"
                      @click="searchText"
                      class="text-capitalize"
                      style="margin-top: -3px"
                    >
                      {{ $t("buttons.search") }}
                    </v-btn>
                  </template>
                </v-text-field>

                <v-divider class="mb-4" />
                
                <div
                  id="firstDiagno"
                  v-for="(item, index) in feedItems"
                  :key="index"
                >
                  <feed-item-card
                    class="test-diagno mb-5"
                    :itemData="item"
                    :newsBat="true"
                    :index="index"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import UserService from "../../services/UserService";
import FeedItemCard from "../../components/Feeds/FeedItemCard.vue";

export default {
  data: () => {
    return {
      offsetProfile: { top: 90 },
      offsetPosts: { top: -810 },

      //////
      feedItems: [],
      loading: false,
      activeTab: 1,
      corporateData: [],
      individualData: [],
      refreshing: false,
      posts: [],
      stories: [],

      loading: false,
      page: 1,
      per_page: 15,
      paginationStop: false,

      searchTextModel: "",
      searchButtonStatus: false,
    };
  },
  components: {
    FeedItemCard,
  },
  methods: {
    clearSearch() {
      this.page = 1;
      this.searchTextModel = "";
      //Input alanına yazıp arama butonuna basmadan temizlerse servisin tetiklenmemesi
      if (this.searchButtonStatus) {
        this.searchButtonStatus = false;
        this.getFeedItems();
      }
    },

    searchText() {
      console.log("search : ", this.searchTextModel);
      this.page = 1;
      this.searchButtonStatus = true;
      this.getFeedItems();
    },

    getFeedItems() {
      let key = "kurumsal_haberler";
      let type = "corporate";
      let groupIds = "";
      this.loading = true;
      setPageLoading(true);
      UserService.getPosts(
        key,
        this.page,
        this.per_page,
        this.searchTextModel,
        groupIds,
        type
      )
        .then((res) => {
          const posts = res.data;
          let _data = [];
          // if ((searchText === "" || page !== 1) && !this.refreshing) {
          if (this.searchTextModel === "" || this.page !== 1) {
            _data = [...this.feedItems, ...posts];
          } else {
            _data = posts;
          }
          if (posts.length == 0) this.paginationStop = true;
          this.feedItems = _data;
        })
        .catch(async (err) => {
          console.log("err : ", err);
          window.showError(err);
        })
        .then(() => {
          this.loading = false;
          setPageLoading(false);
        });
    },

    paginationPage() {
      console.log("paginationPage");
      this.page++;
      this.getFeedItems();
    },

    //Infinite scroll
    scrollTop(e) {
      if (!this.loading) {
        if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100
        ) {
          if (!this.paginationStop) this.paginationPage();
        }
      }
    },
  },
  computed: {},
  destroyed() {
    window.removeEventListener("scroll", this.scrollTop);
  },
  mounted() {
    this.getFeedItems();
    window.addEventListener("scroll", this.scrollTop);
  },
  watch: {},
};
</script>

<style>
.fixed .v-card {
  position: fixed;
  min-width: 253.5px;
}

.fixed-in-flex {
  position: fixed;
}

.vue-sticky-el {
  z-index: 1 !important;
}

.word-wrap {
  word-break: break-word !important;
}
</style>
